import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/CiscoSansTTExtraLight.ttf\",\"weight\":\"300\",\"style\":\"thin\"},{\"path\":\"./fonts/CiscoSansTTLight.ttf\",\"weight\":\"400\",\"style\":\"light\"},{\"path\":\"./fonts/CiscoSansTTRegular.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./fonts/CiscoSansTTLightOblique.ttf\",\"weight\":\"400\",\"style\":\"italic\"},{\"path\":\"./fonts/CiscoSansTTBold.ttf\",\"weight\":\"700\",\"style\":\"bold\"}]}],\"variableName\":\"CiscoSans\"}");
;
import(/* webpackMode: "eager" */ "/build/node_modules/swiper/swiper.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["RobotsTags"] */ "/build/src/components/layout/scripts/robots-tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/build/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/build/src/styles/custom-editor.css");
